// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_native_bridge.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_native_bridge.proto.
 */
export const file_plugnmeet_native_bridge: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Wire format for communication between the webview and the native host.
 * Messages are encoded as proto3 JSON (not binary).
 *
 * @generated from message plugnmeet.NativeBridgeMsg
 */
export type NativeBridgeMsg = Message<"plugnmeet.NativeBridgeMsg"> & {
  /**
   * @generated from field: plugnmeet.NativeBridgeActions action = 1;
   */
  action: NativeBridgeActions;

  /**
   * @generated from oneof plugnmeet.NativeBridgeMsg.payload
   */
  payload: {
    /**
     * @generated from field: plugnmeet.NativeBridgeInitializePublisher initialize_native_publisher = 2;
     */
    value: NativeBridgeInitializePublisher;
    case: "initializeNativePublisher";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeMediaSource media_source = 3;
     */
    value: NativeBridgeMediaSource;
    case: "mediaSource";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeHeartbeat heartbeat = 4;
     */
    value: NativeBridgeHeartbeat;
    case: "heartbeat";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeMediaStatus media_status = 5;
     */
    value: NativeBridgeMediaStatus;
    case: "mediaStatus";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeTrackState track_state = 6;
     */
    value: NativeBridgeTrackState;
    case: "trackState";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeMediaMuted media_muted = 7;
     */
    value: NativeBridgeMediaMuted;
    case: "mediaMuted";
  } | {
    /**
     * @generated from field: plugnmeet.NativeBridgeError error = 8;
     */
    value: NativeBridgeError;
    case: "error";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message plugnmeet.NativeBridgeMsg.
 * Use `create(NativeBridgeMsgSchema)` to create a new message.
 */
export const NativeBridgeMsgSchema: GenMessage<NativeBridgeMsg> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 0);

/**
 * @generated from message plugnmeet.NativeBridgeInitializePublisher
 */
export type NativeBridgeInitializePublisher = Message<"plugnmeet.NativeBridgeInitializePublisher"> & {
  /**
   * @generated from field: string livekit_url = 1;
   */
  livekitUrl: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;

  /**
   * @generated from field: string native_user_id = 3;
   */
  nativeUserId: string;

  /**
   * @generated from field: optional plugnmeet.NativeBridgeE2EE e2ee = 4;
   */
  e2ee?: NativeBridgeE2EE | undefined;
};

/**
 * Describes the message plugnmeet.NativeBridgeInitializePublisher.
 * Use `create(NativeBridgeInitializePublisherSchema)` to create a new message.
 */
export const NativeBridgeInitializePublisherSchema: GenMessage<NativeBridgeInitializePublisher> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 1);

/**
 * @generated from message plugnmeet.NativeBridgeE2EE
 */
export type NativeBridgeE2EE = Message<"plugnmeet.NativeBridgeE2EE"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: optional string key = 2;
   */
  key?: string | undefined;
};

/**
 * Describes the message plugnmeet.NativeBridgeE2EE.
 * Use `create(NativeBridgeE2EESchema)` to create a new message.
 */
export const NativeBridgeE2EESchema: GenMessage<NativeBridgeE2EE> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 2);

/**
 * Used for PUBLISH/UNPUBLISH/MUTE/UNMUTE actions (web -> native).
 *
 * @generated from message plugnmeet.NativeBridgeMediaSource
 */
export type NativeBridgeMediaSource = Message<"plugnmeet.NativeBridgeMediaSource"> & {
  /**
   * @generated from field: plugnmeet.NativeMediaSource source = 1;
   */
  source: NativeMediaSource;
};

/**
 * Describes the message plugnmeet.NativeBridgeMediaSource.
 * Use `create(NativeBridgeMediaSourceSchema)` to create a new message.
 */
export const NativeBridgeMediaSourceSchema: GenMessage<NativeBridgeMediaSource> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 3);

/**
 * Unix milliseconds.
 *
 * @generated from message plugnmeet.NativeBridgeHeartbeat
 */
export type NativeBridgeHeartbeat = Message<"plugnmeet.NativeBridgeHeartbeat"> & {
  /**
   * @generated from field: int64 ts = 1 [jstype = JS_STRING];
   */
  ts: string;
};

/**
 * Describes the message plugnmeet.NativeBridgeHeartbeat.
 * Use `create(NativeBridgeHeartbeatSchema)` to create a new message.
 */
export const NativeBridgeHeartbeatSchema: GenMessage<NativeBridgeHeartbeat> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 4);

/**
 * Native -> web: action confirmation or error report.
 *
 * @generated from message plugnmeet.NativeBridgeMediaStatus
 */
export type NativeBridgeMediaStatus = Message<"plugnmeet.NativeBridgeMediaStatus"> & {
  /**
   * @generated from field: plugnmeet.NativeMediaSource source = 1;
   */
  source: NativeMediaSource;

  /**
   * @generated from field: optional string device_id = 2;
   */
  deviceId?: string | undefined;

  /**
   * @generated from field: optional string error = 3;
   */
  error?: string | undefined;
};

/**
 * Describes the message plugnmeet.NativeBridgeMediaStatus.
 * Use `create(NativeBridgeMediaStatusSchema)` to create a new message.
 */
export const NativeBridgeMediaStatusSchema: GenMessage<NativeBridgeMediaStatus> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 5);

/**
 * Native -> web: track published/unpublished notification.
 *
 * @generated from message plugnmeet.NativeBridgeTrackState
 */
export type NativeBridgeTrackState = Message<"plugnmeet.NativeBridgeTrackState"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: plugnmeet.NativeTrackKind kind = 2;
   */
  kind: NativeTrackKind;

  /**
   * @generated from field: plugnmeet.NativeMediaSource source = 3;
   */
  source: NativeMediaSource;
};

/**
 * Describes the message plugnmeet.NativeBridgeTrackState.
 * Use `create(NativeBridgeTrackStateSchema)` to create a new message.
 */
export const NativeBridgeTrackStateSchema: GenMessage<NativeBridgeTrackState> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 6);

/**
 * Native -> web: mute state confirmation.
 *
 * @generated from message plugnmeet.NativeBridgeMediaMuted
 */
export type NativeBridgeMediaMuted = Message<"plugnmeet.NativeBridgeMediaMuted"> & {
  /**
   * @generated from field: plugnmeet.NativeMediaSource source = 1;
   */
  source: NativeMediaSource;

  /**
   * @generated from field: bool muted = 2;
   */
  muted: boolean;
};

/**
 * Describes the message plugnmeet.NativeBridgeMediaMuted.
 * Use `create(NativeBridgeMediaMutedSchema)` to create a new message.
 */
export const NativeBridgeMediaMutedSchema: GenMessage<NativeBridgeMediaMuted> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 7);

/**
 * Native -> web: For reporting generic errors.
 *
 * @generated from message plugnmeet.NativeBridgeError
 */
export type NativeBridgeError = Message<"plugnmeet.NativeBridgeError"> & {
  /**
   * @generated from field: string msg = 1;
   */
  msg: string;

  /**
   * @generated from field: optional string context = 2;
   */
  context?: string | undefined;
};

/**
 * Describes the message plugnmeet.NativeBridgeError.
 * Use `create(NativeBridgeErrorSchema)` to create a new message.
 */
export const NativeBridgeErrorSchema: GenMessage<NativeBridgeError> = /*@__PURE__*/
  messageDesc(file_plugnmeet_native_bridge, 8);

/**
 * @generated from enum plugnmeet.NativeBridgeActions
 */
export enum NativeBridgeActions {
  /**
   * @generated from enum value: NATIVE_BRIDGE_ACTION_UNSPECIFIED = 0;
   */
  NATIVE_BRIDGE_ACTION_UNSPECIFIED = 0,

  /**
   * web app -> native host
   *
   * @generated from enum value: INITIALIZE_NATIVE_PUBLISHER = 1;
   */
  INITIALIZE_NATIVE_PUBLISHER = 1,

  /**
   * @generated from enum value: PUBLISH_NATIVE_MEDIA = 2;
   */
  PUBLISH_NATIVE_MEDIA = 2,

  /**
   * @generated from enum value: UNPUBLISH_NATIVE_MEDIA = 3;
   */
  UNPUBLISH_NATIVE_MEDIA = 3,

  /**
   * @generated from enum value: MUTE_NATIVE_MEDIA = 4;
   */
  MUTE_NATIVE_MEDIA = 4,

  /**
   * @generated from enum value: UNMUTE_NATIVE_MEDIA = 5;
   */
  UNMUTE_NATIVE_MEDIA = 5,

  /**
   * @generated from enum value: TEARDOWN_NATIVE_PUBLISHER = 6;
   */
  TEARDOWN_NATIVE_PUBLISHER = 6,

  /**
   * @generated from enum value: NATIVE_HEARTBEAT_PING = 7;
   */
  NATIVE_HEARTBEAT_PING = 7,

  /**
   * native host -> web app
   *
   * @generated from enum value: NATIVE_MEDIA_STATUS = 20;
   */
  NATIVE_MEDIA_STATUS = 20,

  /**
   * @generated from enum value: NATIVE_TRACK_PUBLISHED = 21;
   */
  NATIVE_TRACK_PUBLISHED = 21,

  /**
   * @generated from enum value: NATIVE_TRACK_UNPUBLISHED = 22;
   */
  NATIVE_TRACK_UNPUBLISHED = 22,

  /**
   * @generated from enum value: NATIVE_MEDIA_MUTED = 23;
   */
  NATIVE_MEDIA_MUTED = 23,

  /**
   * @generated from enum value: NATIVE_HEARTBEAT_PONG = 24;
   */
  NATIVE_HEARTBEAT_PONG = 24,

  /**
   * @generated from enum value: NATIVE_ERROR = 25;
   */
  NATIVE_ERROR = 25,
}

/**
 * Describes the enum plugnmeet.NativeBridgeActions.
 */
export const NativeBridgeActionsSchema: GenEnum<NativeBridgeActions> = /*@__PURE__*/
  enumDesc(file_plugnmeet_native_bridge, 0);

/**
 * @generated from enum plugnmeet.NativeMediaSource
 */
export enum NativeMediaSource {
  /**
   * @generated from enum value: NATIVE_MEDIA_SOURCE_UNSPECIFIED = 0;
   */
  NATIVE_MEDIA_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MIC = 1;
   */
  MIC = 1,

  /**
   * @generated from enum value: WEBCAM = 2;
   */
  WEBCAM = 2,

  /**
   * @generated from enum value: SCREENSHARE = 3;
   */
  SCREENSHARE = 3,
}

/**
 * Describes the enum plugnmeet.NativeMediaSource.
 */
export const NativeMediaSourceSchema: GenEnum<NativeMediaSource> = /*@__PURE__*/
  enumDesc(file_plugnmeet_native_bridge, 1);

/**
 * @generated from enum plugnmeet.NativeTrackKind
 */
export enum NativeTrackKind {
  /**
   * @generated from enum value: NATIVE_TRACK_KIND_UNSPECIFIED = 0;
   */
  NATIVE_TRACK_KIND_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUDIO = 1;
   */
  AUDIO = 1,

  /**
   * @generated from enum value: VIDEO = 2;
   */
  VIDEO = 2,
}

/**
 * Describes the enum plugnmeet.NativeTrackKind.
 */
export const NativeTrackKindSchema: GenEnum<NativeTrackKind> = /*@__PURE__*/
  enumDesc(file_plugnmeet_native_bridge, 2);

